// src/pages/Equipe.jsx
import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
  setDoc,
  doc,
  deleteDoc,
  getDoc,                    // <<=== IMPORTADO
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";
import {
  LuTrash2,
  LuPlus,
  LuPencil,
  LuCheck,
  LuX,
  LuUser,
  LuLock,
  LuLockOpen,
  LuUsers
} from "react-icons/lu";
import { app } from "../firebase";
import LoadingComLayout from "../components/LoadingComLayout";

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

/* ======================= ESTILOS ======================= */
const Main = styled.main`
  flex: 1;
  padding: 2rem 4rem;
  background: #f3f7ff;
  min-height: 100vh;
  display: flex; flex-direction: column; gap: 1.25rem;
  @media (max-width: 1280px){ padding: 2rem; }
  @media (max-width: 768px){ padding: 1rem; }
`;
const TopBar = styled.div`
  display: flex; align-items: center; justify-content: space-between;
  gap: 1rem;
  @media (max-width: 560px){ flex-direction: column; align-items: stretch; gap:.75rem; }
`;
const Title = styled.h2`
  font-size: 1.5rem; font-weight: 700; color: #1f1a40; margin: .25rem 0 1rem;
`;
const Badge = styled.span`
 font-size:1rem; color:#fff; background:#3a79ed; padding:10px 20px; font-weight:600; border-radius:999px; white-space:nowrap; align-self:flex-start;
 @media (max-width:560px){ align-self:stretch; text-align:center; }
`;
// >> NOVO COMPONENTE DE ESTILO PARA O BOTÃO/LINK
const AssinaturaLink = styled(Badge).attrs({ as: "a" })`
 background: #3a79ed; color: #fff;
 padding: 10px 18px; font-size: 0.95rem; font-weight: 700;
 border-radius: 999px; cursor: pointer; text-decoration: none;
 transition: background-color 0.2s ease;
 &:hover { background: #2f66cb; }
 @media (max-width:560px){ align-self:stretch; text-align:center; }
`;
const Grid = styled.div`
  display: grid; gap: 1rem; grid-template-columns: 2fr 1fr;
  @media (max-width: 1024px){ grid-template-columns: 1fr; }
`;
const Card = styled.div`
  background:#fff; border-radius:1.25rem; min-height:260px; padding:1rem 1rem .9rem;
  box-shadow:0 3px 12px rgba(0,0,0,.16); display:flex; flex-direction:column; align-items:center; justify-content:center; position:relative;
  min-width: 24%;
`;

const CardArea = styled.section`
  background: #fff; border: 1px solid #e6ecf5; border-radius: 1rem;
  box-shadow: 0 6px 20px rgba(58,121,237,.06);
`;
const CardHeader = styled.div`
  display:flex; align-items:center; gap:.6rem;
  padding: 1rem 1.1rem; border-bottom: 1px solid #eef2fb; color: #1f1a40; font-weight: 700;
  svg{ color:#3a79ed; }
`;
const CardBody = styled.div`
  padding: 1rem 1.1rem; display:flex; flex-direction:row; justify-content:flex-start; gap:.9rem; flex-wrap: wrap;
  @media (max-width: 1280px){ flex-direction:column; }
`;
const LockButton = styled.div`
  display:flex; justify-content:center; align-items:center; position:absolute; top:10px; right:10px;
  font-size:1.6rem; width:50px; height:50px; background:#fff; border-radius:50%; padding:6px; cursor:pointer; z-index:2;
  color:${({ active }) => active ? "#3a79ed" : "#9ca3af"}; box-shadow:0 2px 8px rgba(0,0,0,.08);
  @media (hover:hover){ &:hover{ transform:translateY(-1px); } }
`;
const CardImageWrapper = styled.label`
  width:88px; height:88px; margin-bottom:1rem; border-radius:50%; background:#e9e9e9;
  border:${({ hasImage }) => hasImage ? "none" : "2px dashed #868686"};
  display:flex; align-items:center; justify-content:center; overflow:hidden;
  cursor:${({ disabled }) => disabled ? "default" : "pointer"};
  transition: transform .15s ease;
  &:hover{ transform:${({ disabled }) => disabled ? "none" : "translateY(-1px)"}; }
  img{ width:100%; height:100%; object-fit:cover; }
  svg{ font-size:2rem; color:#868686; }
  @media (max-width:640px){ width:76px; height:76px; }
`;
const ContentWrapper = styled.div`
  width:100%; min-height:300px; display:flex; justify-content:space-between; flex-direction:column; align-items:center;
  opacity:${({ faded }) => faded ? 0.25 : 1}; transition:opacity .2s ease; pointer-events:${({ busy }) => busy ? "none" : "auto"};
`;
const Input = styled.input`
  width:100%; padding:.6rem .75rem; margin-bottom:.5rem; border-radius:.75rem; border:1px solid #ccc; font-size:.95rem; color:#1F1A40; background:#fff;
  &::placeholder{ color:#9ca3af; }
  &:focus{ outline:none; border-color:#3a79ed; box-shadow:0 0 0 3px rgba(58,121,237,.15); }
`;
const InfoText = styled.div`
  text-align:center; color:#1F1A40;
  strong{ font-size:1rem; display:block; } span{ font-size:.9rem; color:#4b5563; }
  @media (max-width:640px){ strong{ font-size:.95rem; } span{ font-size:.85rem; } }
`;
const Chips = styled.div` margin-top:.75rem; width:100%; display:flex; gap:.5rem; flex-wrap:wrap; `;
const Chip = styled.span` background:#e6efff; color:#1a3d7c; font-size:.75rem; font-weight:600; padding:4px 10px; border-radius:999px; `;
const ChecklistWrap = styled.div` width:100%; margin-top:.75rem; display:flex; flex-direction:column; gap:.5rem; `;
const ChecklistItem = styled.label`
  display:flex; align-items:center; justify-content:space-between; background:#f3f3f3; border-radius:.75rem; padding:.55rem .8rem;
  border:2px solid ${({ checked }) => checked ? "#3a79ed" : "#ccc"}; font-size:.9rem; font-weight:600; color:#1F1A40; transition:all .2s ease-in-out;
  .box{ width:18px; height:18px; border-radius:4px; border:2px solid ${({ checked }) => checked ? "#3a79ed" : "#bbb"}; background:${({ checked }) => checked ? "#3a79ed" : "transparent"}; display:flex; align-items:center; justify-content:center; }
  input{ display:none; }
`;
const ActionRow = styled.div`
  display:flex; gap:.5rem; margin:.75rem 0 1rem; width:100%;
  @media (max-width:420px){ flex-direction:column; gap:.4rem; }
`;
const Button = styled.button`
  flex:1; padding:.55rem; font-size:.85rem; font-weight:700; border:none; border-radius:.75rem; display:inline-flex; align-items:center; justify-content:center; gap:.4rem; cursor:pointer;
  background:${({ danger }) => danger ? "#ed3a3a" : "#3a79ed"}; color:#fff; transition: transform .12s ease, box-shadow .12s ease, background-color .2s ease;
  &:hover{ background:${({ danger }) => danger ? "#d53232" : "#2f66cb"}; transform:translateY(-1px); box-shadow:0 6px 16px rgba(0,0,0,.06); }
  &:disabled{ opacity:.6; cursor:not-allowed; transform:none; box-shadow:none; }
  @media (max-width:420px){ width:100%; }
`;
const AddCard = styled(Card)`
  justify-content:center; color:#666; border:2px dashed #bbb; min-height:220px; cursor:pointer; transition:background .15s ease, transform .12s ease;
  &:hover{ background:#f7f7f7; transform:translateY(-1px); }
  svg{ margin-bottom:.25rem; }
`;
const AddCardDisabled = styled(Card)`
  justify-content:center; align-items:center; gap:.25rem; color:#6b7280; border:2px dashed #d1d5db; min-height:220px; text-align:center; padding:1.5rem;width:20%;
  @media (max-width:420px){ width:100%; }
`;

/* ===== Overlay & Spinners ===== */
const spin = keyframes`to{ transform: rotate(360deg); }`;
const SavingOverlay = styled.div`
  position:absolute; inset:0; background:rgba(255,255,255,.6); backdrop-filter:blur(1px);
  display:${({ visible }) => visible ? "flex" : "none"}; align-items:center; justify-content:center; z-index:3; border-radius:1.25rem;
`;
const Spinner = styled.div`
  width:18px; height:18px; border-radius:50%; border:3px solid rgba(255,255,255,.4); border-top-color:#fff; animation:${spin} .8s linear infinite;
`;
const SpinnerDark = styled.div`
  width:18px; height:18px; border-radius:50%; border:3px solid rgba(0,0,0,.15); border-top-color:#fff; animation:${spin} .8s linear infinite;
`;

/* ======================= Helpers de validação/erros ======================= */
const isValidEmail = (email) => /^\S+@\S+\.\S+$/.test(email);

const validarAntesDeSalvar = (b, isNovo, criadorUid) => {
  if (!b.nome?.trim()) return "Informe o nome do barbeiro.";
  if (isNovo) {
    if (!b.email?.trim()) return "Informe o e-mail.";
    if (!isValidEmail(b.email.trim())) return "Digite um e-mail válido (ex.: nome@dominio.com).";
    if (!b.senha) return "Informe a senha.";
    if (String(b.senha).length < 6) return "A senha deve ter pelo menos 6 caracteres.";
  }
  if (b.uid !== criadorUid) {
    if (b.comissao === "" || b.comissao == null || Number.isNaN(Number(b.comissao)))
      return "Informe a comissão (%).";
    const c = Number(b.comissao);
    if (c < 0 || c > 100) return "A comissão deve estar entre 0% e 100%.";
  }
  return null;
};

const traduzErroAuth = (message = "") => {
  if (/EMAIL_EXISTS/.test(message)) return "Este e-mail já está cadastrado para outro usuário.";
  if (/INVALID_EMAIL/.test(message)) return "E-mail inválido. Digite no formato nome@dominio.com.";
  if (/WEAK_PASSWORD/.test(message)) return "Senha fraca: mínimo de 6 caracteres.";
  if (/OPERATION_NOT_ALLOWED/.test(message)) return "Criação de usuários desativada no projeto.";
  if (/TOO_MANY_ATTEMPTS_TRY_LATER/.test(message)) return "Muitas tentativas. Tente novamente mais tarde.";
  return null;
};

const traduzErroFirestore = (e) => {
  if (e?.code === "permission-denied") return "Sem permissão para salvar. Verifique as regras do Firestore.";
  if (e?.code === "unavailable") return "Serviço indisponível no momento. Tente novamente.";
  return null;
};

/* ====== Plano → limite de adicionais ====== */
const maxAdicionaisPorPlano = (planId) => {
  if (!planId) return 5; // teste grátis (sem assinatura)
  const id = String(planId).toLowerCase();
  if (id === "single") return 0;
  if (id === "pro") return 5;
  if (id === "enterprise") return Infinity; // ilimitado
  return 5; // fallback seguro
};

/* ======================= Firebase Auth extra ======================= */
const criarUsuarioSemDeslogar = async (email, senha) => {
  const API_KEY = "AIzaSyCO-hasCrJVbdE2w7fIxyHZh6Ej1jZzvrs";
  const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${API_KEY}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password: senha, returnSecureToken: false })
  });
  const data = await response.json();
  if (response.ok) return data.localId;
  throw new Error(data?.error?.message || "SIGNUP_FAILED");
};

/* ======================= COMPONENTE ======================= */
export default function Equipe() {
  const [barbeariaId, setBarbeariaId] = useState(null);
  const [barbeiros, setBarbeiros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [servicos, setServicos] = useState([]);
  const [criadorUid, setCriadorUid] = useState(null);
  const [barbeirosAdicionaisPermitidos, setBarbeirosAdicionaisPermitidos] = useState(0);
  const [barbeirosAdicionaisCadastrados, setBarbeirosAdicionaisCadastrados] = useState(0);
  const [planoId, setPlanoId] = useState(null);
  const [salvandoIndex, setSalvandoIndex] = useState(null);
  const navigate = useNavigate();

  const limiteAtingido = barbeirosAdicionaisPermitidos !== Infinity &&
    barbeirosAdicionaisCadastrados >= barbeirosAdicionaisPermitidos;

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) return navigate("/login");

      try {
        const q = query(collection(db, "barbearia"), where("criadorUid", "==", user.uid));
        const snap = await getDocs(q);

        if (!snap.empty) {
          const barbeariaDoc = snap.docs[0];
          const id = barbeariaDoc.id;
          const data = barbeariaDoc.data();

          setBarbeariaId(id);
          setCriadorUid(data.criadorUid);

          // 1) Carregar serviços
          await carregarServicos(id);

          // 2) Ler plano em /assinatura/config
          await carregarLimitePorAssinatura(id);

          // 3) Carregar barbeiros e contar adicionais ativos
          const lista = await carregarBarbeiros(id);
          if (Array.isArray(lista)) {
            contarBarbeirosAdicionais(lista, data.criadorUid);
          }
        }
      } catch (error) {
        console.error("Erro ao carregar dados da barbearia:", error);
        // Fallback (teste grátis)
        setBarbeirosAdicionaisPermitidos(5);
      }

      setLoading(false);
    });

    return () => unsub();
  }, []);

  const carregarLimitePorAssinatura = async (id) => {
    try {
      const cfgRef = doc(db, `barbearia/${id}/assinatura/config`);
      const cfgSnap = await getDoc(cfgRef);
      const pId = cfgSnap.exists() ? (cfgSnap.data()?.planId || null) : null;
      setPlanoId(pId);
      setBarbeirosAdicionaisPermitidos(maxAdicionaisPorPlano(pId));
    } catch (e) {
      console.warn("Não foi possível ler assinatura/config:", e);
      setPlanoId(null);
      setBarbeirosAdicionaisPermitidos(5); // teste grátis
    }
  };

  const carregarBarbeiros = async (id) => {
    const snap = await getDocs(collection(db, `barbearia/${id}/barbeiros`));
    const lista = snap.docs.map((docu) => {
      const d = docu.data();
      return {
        id: docu.id,
        ...d,
        servicosIds: d.servicosIds || [],
        comissao: d.comissao ?? 40,
        editando: false,
        file: null,
        preview: d.foto || "",
      };
    });

    setBarbeiros(lista);
    return lista;
  };

  const contarBarbeirosAdicionais = (lista, criadorUid) => {
    const adicionaisAtivos = lista.filter(b => b.uid !== criadorUid && b.status !== "inativo").length;
    setBarbeirosAdicionaisCadastrados(adicionaisAtivos);
  };

  const carregarServicos = async (barbeariaId) => {
    const snap = await getDocs(collection(db, `barbearia/${barbeariaId}/servico`));
    const lista = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setServicos(lista);
  };

  const handleChange = (index, campo, valor) => {
    const novos = [...barbeiros];
    novos[index][campo] = valor;
    setBarbeiros(novos);
  };

  const handleImage = (index, file) => {
    const novos = [...barbeiros];
    novos[index].file = file;
    novos[index].preview = URL.createObjectURL(file);
    setBarbeiros(novos);
  };

  const uploadImagem = async (file, nome, barbeariaId, uid) => {
    const imageRef = ref(
      storage,
      `${barbeariaId}/barbeiros/${uid || nome}-${Date.now()}.jpeg`
    );
    await uploadBytes(imageRef, file);
    return await getDownloadURL(imageRef);
  };

  const confirmar = async (index) => {
    const b = barbeiros[index];
    const isNovo = !b.id;

    const erroValidacao = validarAntesDeSalvar(b, isNovo, criadorUid);
    if (erroValidacao) { alert(erroValidacao); return; }

    // Limites por plano
    if (isNovo) {
      if (barbeirosAdicionaisPermitidos === 0) {
        return alert("Seu plano atual não permite barbeiros adicionais.");
      }
      if (limiteAtingido) {
        return alert("Limite de barbeiros adicionais ativos atingido. Inative algum para adicionar outro.");
      }
    }

    if (salvandoIndex !== null) return;

    setSalvandoIndex(index);
    try {
      let uid = b.id;
      const nomeTrim = b.nome.trim();
      const emailTrim = (b.email || "").trim().toLowerCase();

      if (isNovo) {
        try {
          uid = await criarUsuarioSemDeslogar(emailTrim, b.senha);
        } catch (err) {
          const msgAmigavel = traduzErroAuth(err?.message);
          alert(msgAmigavel || `Erro ao criar usuário: ${err?.message || "tente novamente"}`);
          return;
        }
      }

      let url = b.foto;
      if (b.file) {
        try {
          url = await uploadImagem(b.file, nomeTrim || "barbeiro", barbeariaId, uid);
        } catch (e) {
          alert("Não foi possível enviar a foto. Tente uma imagem menor ou outro arquivo.");
        }
      }

      const payload = {
        nome: nomeTrim,
        email: emailTrim,
        foto: url,
        uid,
        servicosIds: b.servicosIds || [],
      };

      if (uid !== criadorUid) payload.comissao = b.comissao ?? 40;
      if (isNovo) payload.cargo = (uid === criadorUid) ? "proprietario" : "barbeiro";

      await setDoc(doc(db, `barbearia/${barbeariaId}/barbeiros`, uid), payload, { merge: true });

      const lista = await carregarBarbeiros(barbeariaId);
      if (Array.isArray(lista)) contarBarbeirosAdicionais(lista, criadorUid);
    } catch (error) {
      console.error("Erro ao salvar:", error);
      const msgFs = traduzErroFirestore(error);
      alert(msgFs || "Erro ao salvar barbeiro. Tente novamente.");
    } finally {
      setSalvandoIndex(null);
    }
  };

  const editar = (index) => {
    const novos = [...barbeiros];
    novos[index].editando = true;
    setBarbeiros(novos);
  };

  const cancelar = (index) => {
    const novos = [...barbeiros];
    if (!novos[index].id) {
      novos.splice(index, 1);
    } else {
      novos[index].editando = false;
    }
    setBarbeiros(novos);
  };

  const excluir = async (index) => {
    const b = barbeiros[index];
    if (b.id) {
      const confirmDel = window.confirm("Deseja excluir este barbeiro?");
      if (!confirmDel) return;
      await deleteDoc(doc(db, `barbearia/${barbeariaId}/barbeiros/${b.id}`));
      const lista = await carregarBarbeiros(barbeariaId);
      if (Array.isArray(lista)) contarBarbeirosAdicionais(lista, criadorUid);
    } else {
      const novos = [...barbeiros];
      novos.splice(index, 1);
      setBarbeiros(novos);
    }
  };

  const adicionar = () => {
    if (limiteAtingido || barbeirosAdicionaisPermitidos === 0) {
      alert(barbeirosAdicionaisPermitidos === 0
        ? "Seu plano atual não permite barbeiros adicionais."
        : "Limite de barbeiros adicionais ativos atingido. Inative algum para adicionar outro.");
      return;
    }
    const todosServicosIds = servicos.map(s => s.id);
    setBarbeiros([
      ...barbeiros,
      {
        nome: "",
        email: "",
        senha: "",
        foto: "",
        preview: "",
        file: null,
        editando: true,
        servicosIds: todosServicosIds
      },
    ]);
  };

  const alternarStatus = async (index) => {
    const b = barbeiros[index];
    if (!b.id) return;

    const estaInativo = b.status === "inativo";
    const querAtivar = estaInativo;

    if (querAtivar && b.uid !== criadorUid && limiteAtingido) {
      alert("Limite de barbeiros adicionais ativos atingido.");
      return;
    }

    const novoStatus = estaInativo ? null : "inativo";

    try {
      await setDoc(doc(db, `barbearia/${barbeariaId}/barbeiros`, b.id), { status: novoStatus }, { merge: true });
      const lista = await carregarBarbeiros(barbeariaId);
      if (Array.isArray(lista)) contarBarbeirosAdicionais(lista, criadorUid);
    } catch (error) {
      console.error("Erro ao alternar status:", error);
      alert(traduzErroFirestore(error) || "Erro ao alternar status do barbeiro.");
    }
  };

  if (loading) return <LoadingComLayout />;

  const limiteTexto = barbeirosAdicionaisPermitidos === Infinity ? "∞" : barbeirosAdicionaisPermitidos;

  return (
    <>
      <Main>
        <TopBar>
          <Badge>
            Barbeiros adicionais ativos: <strong>{barbeirosAdicionaisCadastrados} / {limiteTexto}</strong>
          </Badge>
          {/* NOVO LINK/BOTÃO PARA GERENCIAR ASSINATURAS */}
          {(limiteAtingido || barbeirosAdicionaisPermitidos === 0) && (
            <AssinaturaLink
              href="/assinatura" // << Altere para a rota correta da sua tela de assinaturas
            >
              Mudar Plano
            </AssinaturaLink>
          )}
        </TopBar>

        <CardArea>
          <CardHeader><LuUsers />Gerencie a Equipe</CardHeader>
          <CardBody>
            {barbeiros.map((b, index) => {
              const inativo = b.status === "inativo";
              const isSaving = salvandoIndex === index;
              return (
                <Card key={index}>
                  <SavingOverlay visible={isSaving}>
                    <SpinnerDark />
                    <span style={{ marginLeft: 10, fontWeight: 700, color: "#1F1A40" }}>Salvando…</span>
                  </SavingOverlay>
                  {b.uid !== criadorUid && (
                    <LockButton
                      active={inativo}
                      onClick={() => !isSaving && alternarStatus(index)}
                      title={inativo ? (limiteAtingido ? "Limite atingido: inative outro para reativar" : "Reativar barbeiro") : "Inativar barbeiro"}
                    >
                      {inativo ? <LuLock /> : <LuLockOpen />}
                    </LockButton>
                  )}
                  <ContentWrapper faded={inativo} busy={isSaving}>
                    <input
                      type="file"
                      id={`file-${index}`}
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => handleImage(index, e.target.files[0])}
                      disabled={isSaving}
                    />
                    <CardImageWrapper
                      htmlFor={b.editando && !isSaving ? `file-${index}` : undefined}
                      hasImage={!!b.preview}
                      disabled={!b.editando || isSaving}
                    >
                      {b.preview ? <img src={b.preview} alt="preview" /> : <LuUser />}
                    </CardImageWrapper>
                    {b.editando ? (
                      <>
                        <Input
                          placeholder="Nome"
                          value={b.nome}
                          onChange={(e) => handleChange(index, "nome", e.target.value)}
                          disabled={isSaving}
                        />
                        {!b.id && (
                          <>
                            <Input
                              placeholder="Email"
                              value={b.email}
                              onChange={(e) => handleChange(index, "email", e.target.value)}
                              disabled={isSaving}
                            />
                            <Input
                              placeholder="Senha"
                              type="password"
                              value={b.senha}
                              onChange={(e) => handleChange(index, "senha", e.target.value)}
                              disabled={isSaving}
                            />
                          </>
                        )}
                        {b.uid !== criadorUid && (
                          <Input
                            type="number"
                            placeholder="Comissão (%)"
                            value={b.comissao}
                            onChange={(e) => handleChange(index, "comissao", Number(e.target.value))}
                            required min={0} max={100} disabled={isSaving}
                          />
                        )}
                        {servicos.length > 0 && (
                          <ChecklistWrap>
                            <p style={{ fontWeight: 800, fontSize: "0.85rem", margin: 0 }}>Serviços:</p>
                            {servicos.map((servico) => {
                              const checked = b.servicosIds?.includes(servico.id);
                              return (
                                <ChecklistItem key={servico.id} checked={checked}>
                                  <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
                                    <div className="box">
                                      {checked && <LuCheck style={{ color: "#fff", fontSize: "0.9rem" }} />}
                                    </div>
                                    {servico.nome}
                                  </div>
                                  <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={(e) => {
                                      const novos = [...barbeiros];
                                      const ids = novos[index].servicosIds || [];
                                      if (e.target.checked) ids.push(servico.id);
                                      else {
                                        const idx = ids.indexOf(servico.id);
                                        if (idx !== -1) ids.splice(idx, 1);
                                      }
                                      novos[index].servicosIds = ids;
                                      setBarbeiros(novos);
                                    }}
                                    disabled={isSaving}
                                  />
                                </ChecklistItem>
                              );
                            })}
                          </ChecklistWrap>
                        )}
                        <ActionRow>
                          <Button onClick={() => confirmar(index)} disabled={isSaving}>
                            {isSaving ? (<><Spinner /> Salvando…</>) : (<><LuCheck /> Confirmar</>)}
                          </Button>
                          <Button danger onClick={() => cancelar(index)} disabled={isSaving}>
                            <LuX /> Cancelar
                          </Button>
                        </ActionRow>
                      </>
                    ) : (
                      <>
                        <InfoText>
                          <strong>{b.nome}</strong>
                          <span>{b.email}</span>
                        </InfoText>
                        {b.uid !== criadorUid && b.comissao !== undefined && (
                          <span style={{ fontSize: "0.85rem", color: "#374151", marginTop: "0.5rem" }}>
                            Comissão: <strong>{b.comissao}%</strong>
                          </span>
                        )}
                        {b.servicosIds?.length > 0 && servicos.length > 0 && (
                          <Chips>
                            {servicos.filter((s) => b.servicosIds.includes(s.id)).map((s) => (
                              <Chip key={s.id}>{s.nome}</Chip>
                            ))}
                          </Chips>
                        )}
                        <ActionRow>
                          <Button onClick={() => editar(index)} disabled={isSaving}><LuPencil /> Editar</Button>
                          {b.id !== criadorUid && (
                            <Button
                              danger
                              onClick={() => excluir(index)}
                              disabled={isSaving}
                            >
                              <LuTrash2 /> Excluir
                            </Button>
                          )}
                        </ActionRow>
                      </>
                    )}
                  </ContentWrapper>
                </Card>
              );
            })}
            {barbeirosAdicionaisPermitidos !== 0 && !limiteAtingido ? (
              <AddCard onClick={adicionar} title="Adicionar barbeiro adicional">
                <LuPlus size={24} />
                Adicionar Barbeiro
              </AddCard>
            ) : (
              <AddCardDisabled>
                <div style={{ opacity: .8 }}>
                  <LuLock style={{ fontSize: 26 }} />
                </div>
                <div style={{ fontWeight: 700, marginTop: 6 }}>
                  {barbeirosAdicionaisPermitidos === 0
                    ? "Seu plano atual não permite barbeiros adicionais"
                    : "Limite de barbeiros adicionais ativos atingido"}
                </div>
                <div style={{ fontSize: ".9rem", marginTop: 4 }}>
                  {barbeirosAdicionaisPermitidos === 0
                    ? "Faça upgrade para o Pro ou Enterprise para liberar vagas."
                    : "Inative um barbeiro para liberar vaga."}
                </div>
              </AddCardDisabled>
            )}
          </CardBody>
        </CardArea>
      </Main>
    </>
  );
}
